var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 40C40.5228 40 45 35.5228 45 30C45 24.4772 40.5228 20 35 20C29.4772 20 25 24.4772 25 30C25 35.5228 29.4772 40 35 40Z",
    fill: "#46AF72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.75 60C54.2 58.9 52.8 57.7 51.65 56.4L44.65 48.65C43.7 47.6 42.5 46.75 41.2 46.15C39.75 45.45 38.1 45 36.4 45H36.25C30.05 45 25 50.05 25 56.25V60H10V100C10 105.5 14.5 110 20 110H100C105.5 110 110 105.5 110 100V60H55.75ZM35 100H25V70H35V100ZM55 100H45V70H55V100ZM75 100H65V70H75V100ZM95 100H85V70H95V100ZM87.1 36.05C89.95 39.15 91.2 43.1 90.45 47.05L89.9 50H99.45L99.75 47.85C100.8 41.05 98.4 34.3 93.25 29.3L92.9 28.95C90.05 25.85 88.8 21.9 89.55 17.95L90 15H80.55L80.25 17.15C79.25 23.95 81.6 30.7 86.75 35.75L87.1 36.05ZM67.1 36.05C69.95 39.15 71.2 43.1 70.45 47.05L69.9 50H79.45L79.75 47.85C80.8 41.05 78.4 34.3 73.25 29.3L72.9 28.95C70.05 25.85 68.8 21.9 69.55 17.95L70 15H60.55L60.25 17.15C59.25 23.95 61.6 30.7 66.75 35.75L67.1 36.05Z",
    fill: "#46AF72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.70f7aa7e7f9c0b7634ca443be5274f2a.svg";
export { ForwardRef as ReactComponent };